module.exports = [{
      plugin: require('/Users/formidable/dev/sauce-contributions/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/formidable/dev/sauce-contributions/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
